/**
 * @generated SignedSource<<f75e9922b897a7d7e4fe6c25132820e4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FlightInfoSegmentInfo_segment$data = {
  readonly arrivalDatetime: string;
  readonly departDatetime: string;
  readonly flightNumber: string;
  readonly supplier: string;
  readonly " $fragmentType": "FlightInfoSegmentInfo_segment";
};
export type FlightInfoSegmentInfo_segment$key = {
  readonly " $data"?: FlightInfoSegmentInfo_segment$data;
  readonly " $fragmentSpreads": FragmentRefs<"FlightInfoSegmentInfo_segment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FlightInfoSegmentInfo_segment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "supplier",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "flightNumber",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "departDatetime",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "arrivalDatetime",
      "storageKey": null
    }
  ],
  "type": "FlightSegment",
  "abstractKey": null
};

(node as any).hash = "dff824cdfd94b09661734e586e66b708";

export default node;
